import {getStack} from '@ns/ns-contentstack-lib';
import {CheckoutModeService, ShippingService} from "@nuskin/ns-shop";
import {demoShippingAddresses, mrktConfg, shippingAddressStrings, demoTdcStrings} from './demoData';
import {RunConfigService} from "@nuskin/ns-util";
import {UserService} from "@nuskin/ns-account";
import {getConfiguration, getCachedConfigField} from "@nuskin/configuration-sdk";
import { fields } from './marketSettings';
import STATE_CONFIG from './stateConfig';

const INPUT = 'input';
const ERROR = 'error';
const COMPLETE_STATE = "complete";
const ADD_ADDRESS_STATE = "add-address";
const PHONE = 'phone';
const MOBILE_PHONE = 'mobilePhone';


// const ADDRESSERROR = 'addressError';

const mixin = {
    props: {
        addedAddress: {
            type: Object,
            default() {
                return null;
            }
        },
        demo: {
            type: Boolean,
            default() {
                return false;
            }
        },
        translations: {
            type: Object,
            default() {
                return shippingAddressStrings;
            }
        },
        distName: String,
        csApiKey: {
          type: String,
          required: true
        },
        csDeliveryToken: {
          type: String,
          required: true
        },
        csEnvironment: {
          type: String,
          required: true
        }
    },

    data() {
        return {
            addressList: null,
            alerts: [],
            canDelete: false,
            country: null,
            isGuest: false,
            hideShippingPostalCode: false,
            showShipFrom: false,
            language: null,
            shippingAddressFormat: null,
            formCountry: null,
            formData: {},
            formFields: fields,
            requiredFields: [],
            agreeToSave: false,
            editingAddress: false,
            setAsDefault: false,
            afterGavView: COMPLETE_STATE,
            t: {},
            checkoutStrings: demoTdcStrings,
            totalClicks: 0,
            addressConfirmed: false,
            // showGav: false,
            inputAddress: null,
            distributorName: "",
            user: {}
        };
    },

    watch: {

    },

    computed: {
        isDistributor() {
            return this.user && this.user.isDistributor();
        },
        disableAddressName() {
            return this.disableEditShippingAddressName && !this.isDistributor;
        }
    },

    methods: {
        initAddressForm(address, nextView) {
            if (address) {
                this.formData = {...address};
            } else {
                // Populate address name for JP and guest users
                if (this.isGuest || this.disableAddressName) {
                    this.formData = {
                        addressName: this.distributorName,
                        country: this.country,
                        ...(this.isGuest && {email: this.user.email}),
                        ...(this.isGuest && this.user.phone && {phoneCountry: this.user.phone.country}),
                        ...(this.isGuest && this.user.phone && {phone: this.user.phone.number})
                    }
                } else {
                    this.formData = {country: this.country};
                }
            }
            this.formCountry = this.formData.country;
            this.setAsDefault = address ? address.defaultShipping : false;
            this.afterGavView = nextView;

            this.showState(ADD_ADDRESS_STATE);
            this.editingAddress = true;
            this.agreeToSave = !this.isGuest;
        },

        getAddressesFor() {
            return fields[this.country].countryList ? '' : this.country;
        },

        filterAddressesList(addresses = []) {
            const markets = fields[this.country].countryList;

            return !markets
                ? addresses
                : addresses.filter((address) => {
                    return markets.some((market) => {
                        return market.value.toUpperCase() === address.shippingCountry;
                    });
                })
        },

        /**
         * Loads the user's save addresses
         */
        async getSavedAddresses() {
            let addresses = this.addressList;

            if (!addresses) {
                if (this.demo) {
                    addresses = demoShippingAddresses.map((addr) => Object.assign({}, {...addr}));
                } else {
                    try {
                        const response = await ShippingService.getShippingAddressList(this.getAddressesFor());
                        addresses =
                            response && response.ShippingAddressList
                                ? this.filterAddressesList(response.ShippingAddressList)
                                : [];
                    } catch (e) {
                        addresses = [];
                        this.addToAlerts();
                        console.error("Error getting address list", e);
                    }
                }
                if (this.addedAddress) {
                    this.addedAddress.propsAdded = true;
                    if (!addresses.find(address => this.addressMatches(address, this.addedAddress))) {
                        addresses.unshift(this.addedAddress);
                    }
                }
            }
            this.canDelete = addresses.length > 1;
            // console.log(JSON.stringify(addresses));
            return addresses.map(serverAddress => this.convertToLocalFormat(serverAddress));
        },

        missingRequiredFields(address) {
            let result = false;
            this.requiredFields.forEach((requiredField) => {
                const checkFields = [requiredField];
                if (requiredField === PHONE) checkFields.push(MOBILE_PHONE);
                if (requiredField === MOBILE_PHONE) checkFields.push(PHONE)
                result = result || !checkFields.some((fieldToCheck) => address[fieldToCheck]);
            })
            return result;
        },

        /**
         * Gets the default address.  Loads the addresses if not already loaded.
         *
         * @return {Promise<null>}
         */
        async getDefaultAddress() {
            if (!this.addressList) {
                this.addressList = await this.getSavedAddresses()
            }
            if (this.addressList.length > 0) {
                this.defaultShippingAddress = this.addressList.reduce(
                    (address, item) => {
                        if (!address.city || (!address.propsAdded && (item.defaultShipping || item.propsAdded))) {
                            address = item;
                        }
                        return address;
                    },
                    { country: this.country }
                );
            }

            return this.defaultShippingAddress;
        },

        /**
         * Deletes address from the server if it is saved and removes it
         * from the address list.  Also logs the event in the datalayer.
         *
         * @param {*} addressId - ID of the addres to delete
         * param {boolean} fromForm - true if deleting from edit form
         */
        async deleteAddress(addressId/*, fromForm*/) {
            let deleted = true;

            if (this.isSavedAddress(addressId)) {
                try {
                    await ShippingService.deleteShippingAddress(addressId);
                } catch (err) {
                    console.error(`err: ${err}`);
                    // TODO
                    // events.tag(ADDRESSERROR, {
                    //     context: this.context,
                    //     errorCategory: 'Failed to delete payment: ' + err
                    // });
                    deleted = false;
                }
            }
            if (deleted) {
                const index = this.addressList.findIndex(a => a.id === addressId);
                // TODO
                // events.tag(PAYMENTREMOVED, {
                //     context: this.context,
                //     paymentType: this.payments[index].paymentTypeDescription,
                //     method: fromForm ? 'deleteButton' : 'deleteMenuOption'
                // });
                this.$delete(this.addressList, index);
                this.canDelete = this.addressList.length > 1;
            }

            return deleted;
        },

        /**
         * Saves an edited address
         *
         * @param {*} address
         */
        async editAddress(address/*, method = 'notSet'*/) {
            let aIndex;

            if (address.defaultShipping) {
                await this.unsetDefaultAddress(address);
            }
            if (this.isSavedAddress(address.id)) {
                const response = await ShippingService.putShippingAddress(this.convertToSavedFormat(address));
                aIndex = this.addressList.findIndex(a => a.id === response.ShippingAddress.beShippingAddressId);

                // TODO
                // If the user updated the payment to be the defaultShipping
                // if (response.defaultShipping && !this.addressList[aIndex].defaultShipping) {
                //     this.updateAnalytics(PAYMENTSETASDEFAULT, response.paymentTypeDescription, method);
                // }
                // this.updateAnalytics(PAYMENTEDITED, payment.paymentTypeDescription);

                this.$set(this.addressList, aIndex,
                    Object.assign(this.convertToLocalFormat(response.ShippingAddress), {verified: address.verified}));
            } else {
                aIndex = this.addressList.findIndex(a => a.id === address.id);
                this.$set(this.addressList, aIndex, address);
            }

            this.canDelete = this.addressList.length > 1;
            return this.addressList[aIndex];
        },

        /**
         * addAddress
         *
         * @param address
         * @param saveToProfile
         * @return {Promise<number>}
         */
        async addAddress(address, saveToProfile = true) {
            let retVal;

            if (address.defaultShipping) {
                await this.unsetDefaultAddress(address);
            }
            if (UserService.isLoggedIn() && saveToProfile) {
                let response = await ShippingService.postShippingAddress(this.convertToSavedFormat(address));
                this.addressList.push(
                    Object.assign(this.convertToLocalFormat(response.ShippingAddress), {verified: address.verified}));
                // TODO
                // if (response.defaultShipping) {
                //     this.updateAnalytics(PAYMENTSETASDEFAULT, response.paymentTypeDescription, method);
                // }
                // this.updateAnalytics(PAYMENTADDED, response.paymentTypeDescription, method);
                retVal = response.ShippingAddress.beShippingAddressId;
            } else {
                //Assign a bePaymentTypeId as a unique identifier
                address.id = saveToProfile ? Date.now() : -(Date.now());
                this.addressList.push(address);
                retVal = address.id;
            }

            this.canDelete = this.addressList.length > 1;
            return retVal;
        },

        getRegionName(stateValue) {
            let region = stateValue;
            if (stateValue && STATE_CONFIG[this.country]) {
                const reg = STATE_CONFIG[this.country].stateList.find((el) => el.key === stateValue);
                region = (reg && reg.value) || region;
            }
            return region;
        },

        /**
         * Converts a shipping address to local address object
         * @param {Object} shippingAddress
         * @returns {Object} billingAddress
         */
        convertToLocalFormat(shippingAddress) {
            const address = {
                id: shippingAddress.beShippingAddressId,
                addressName: shippingAddress.shippingAddressName,
                alias: shippingAddress.shippingAlias,
                address1: shippingAddress.shippingAddress1,
                address2: shippingAddress.shippingAddress2,
                address3: shippingAddress.shippingAddress3,
                city: shippingAddress.shippingCity,
                district: shippingAddress.shippingCounty,
                region: shippingAddress.shippingState,
                postalCode: shippingAddress.shippingPostalCode,
                country: shippingAddress.shippingCountry,
                phone: shippingAddress.shippingPhone,
                phoneCountry: shippingAddress.shippingPhoneCountry,
                mobilePhone: shippingAddress.shippingMobilePhone,
                mobilePhoneCountry: shippingAddress.shippingMobilePhoneCountry,
                instructions: shippingAddress.shippingInstructions,
                email: shippingAddress.shippingEmail,
                addressType: shippingAddress.addressType,
                defaultShipping: shippingAddress.defaultShipping
            };

            address.verified = shippingAddress.verified === true;

            return address;
        },

        /**
         * Converts a shipping address to local address object
         * @param {Object} shippingAddress
         * @returns {Object} billingAddress
         */
        convertToSavedFormat(shippingAddress) {
            const address = {
                beShippingAddressId: shippingAddress.id,
                shippingAddressName: shippingAddress.addressName,
                shippingAlias: shippingAddress.alias,
                shippingAddress1: shippingAddress.address1,
                shippingAddress2: shippingAddress.address2,
                shippingAddress3: shippingAddress.address3,
                shippingCity: shippingAddress.city,
                shippingCounty: shippingAddress.district,
                shippingState: shippingAddress.region,
                shippingPostalCode: shippingAddress.postalCode,
                shippingCountry: shippingAddress.country,
                shippingPhone: shippingAddress.phone,
                shippingPhoneCountry: shippingAddress.phoneCountry,
                shippingMobilePhone: shippingAddress.mobilePhone,
                shippingMobilePhoneCountry: shippingAddress.mobilePhoneCountry,
                shippingInstructions: shippingAddress.instructions,
                shippingEmail: shippingAddress.email,
                addressType: shippingAddress.addressType,
                defaultShipping: shippingAddress.defaultShipping
            };

            address.verified = shippingAddress.verified === true;

            return address;
        },

        /**
         * Adds a new address to the user's profile.
         *
         * @param address
         * @return {Promise<void>}
         */
        // async addAddress(address) {
        //     const response = await ShippingService.postShippingAddress(address);
        // }

        /**
         * Un-sets existing default address, not the address passed in.
         */
        async unsetDefaultAddress(address) {
            // if the address has default payment set and is not the current payment being edited then remove the default flag
            let defaultAddress = this.addressList.find(
                a => a.defaultShipping === true && a.id !== address.id
            );

            if (defaultAddress) {
                defaultAddress.defaultShipping = false;
                if (this.isSavedAddress(defaultAddress.id)) {
                    try {
                        await ShippingService.putShippingAddress(this.convertToSavedFormat(defaultAddress));
                    } catch (err) {
                        defaultAddress.defaultShipping = true;
/*
                        events.tag(ADDRESSERROR, {
                            context: this.context,
                            errorCategory: 'Failed to unset the current default address: ' + err
                        });
*/
                        throw err;
                    }
                }
            }
        },

        async updateDefaultAddress(address/*, method = 'notSet'*/) {
            if (!address.defaultShipping) {
                if (this.isSavedAddress(address.id)) {
                    await this.unsetDefaultAddress(address);
                    address.defaultShipping = true;
                    await ShippingService.putShippingAddress(this.convertToSavedFormat(address));
                    this.updateDefaultAddressOrder();
                    // this.updateAnalytics(PAYMENTSETASDEFAULT, address.paymentTypeDescription, method);
                } else {
                    this.unsetDefaultAddress(address);
                    address.defaultShipping = true;
                    this.updateDefaultAddressOrder();
                    // this.updateAnalytics(PAYMENTSETASDEFAULT, address.paymentTypeDescription, method);
                }
            }
        },

        updateDefaultAddressOrder() {
            if (Array.isArray(this.addressList)) {
                let defaultIndex = this.addressList.findIndex(a => a.defaultShipping);
                let a = { ...this.addressList[defaultIndex] };
                if (defaultIndex > 0) {
                    this.$delete(this.addressList, defaultIndex);
                    this.addressList.unshift(a);
                }
            }
        },

        /**
         * Returns true if the address is saved to the shipping service
         * If bePaymentTypeId is < 0 then the id was assigned when added just for reference
         * @param beShippingAddressId
         * @returns {boolean}
         */
        isSavedAddress(beShippingAddressId) {
            return beShippingAddressId > 0 && !this.demo;
        },

        emitSelectedAddress(address) {
            let emmitedAddress = null;

            if (address) {
                emmitedAddress = {...address};
                if (!this.isSavedAddress(emmitedAddress.id)) {
                    emmitedAddress.id = null;
                }
                emmitedAddress = {...this.convertToSavedFormat(emmitedAddress)};
            }
            this.$emit(INPUT, emmitedAddress);
        },

        resetForms() {
            if (this.$refs.addAddressForm) {
                this.$refs.addAddressForm.reset();
            }
        },

        /**
         *
         * @param {string} tag
         * @param {string} description
         * @param {string} method
         */
/*
        updateAnalytics(tag, description, method = '') {
            events.tag(tag, {
                context: this.context,
                paymentType: description,
                method: method
            });
        }
*/

        getMarketConfig() {
            if (this.demo) {
                this.showShipFrom = mrktConfg.showShipFrom;
                this.hideShippingPostalCode = mrktConfg.checkout.hideShippingPostalCode;
                this.shippingAddressFormat = mrktConfg.checkout.shippingAddressFormat;
                this.disableEditShippingAddressName = mrktConfg.checkout.disableEditShippingAddressName;
                this.enableAddressValidation = mrktConfg.enableAddressValidation;
                this.validateShippingAddressOnLoad = mrktConfg.checkout.validateShippingAddressOnLoad;
                this.showSignatureRequired = mrktConfg.checkout.showSignatureRequired;
            } else {
                this.showShipFrom = getCachedConfigField('showShipFrom');
                this.hideShippingPostalCode = getCachedConfigField('hideShippingPostalCode');
                this.shippingAddressFormat = getCachedConfigField('shippingAddressFormat');
                this.disableEditShippingAddressName = getCachedConfigField('disableEditShippingAddressName');
                this.enableAddressValidation = getCachedConfigField('enableAddressValidation');
                this.validateShippingAddressOnLoad = getCachedConfigField('validateShippingAddressOnLoad');
                this.showSignatureRequired = getCachedConfigField('showSignatureRequired');
            }
        },

        /**
         * Returns `true` if the two addresses are equivalent, `false` otherwise.
         * @param {nuskin.newShop.ShippingAddress} address1
         * @param {nuskin.newShop.ShippingAddress} address2
         * @return {boolean}
         */
        addressMatches(address1, address2) {
            const match = (a, b) => (!a && !b) || (a === b);
            return ([
                'shippingAddressName',
                'shippingAddress1',
                'shippingAddress2',
                'shippingCity',
                'shippingCounty',
                'shippingState',
                'shippingPostalCode',
                'shippingCountry'
            ]).every((prop) => match(address1[prop], address2[prop]));
        },

        addToAlerts(message = this.t.serverErrorMessage, context = ERROR, title = this.t.serverErrorTitle) {
            if (!this.alerts.find(a => a.type = context && a.message === message)) {
                const errors = this.alerts.filter(a => a.context === ERROR);
                const others = this.alerts.filter(a => a.context !== ERROR);
                const alert = {
                    id: Date.now(),
                    context: context,
                    title: title,
                    message: message
                };
                context === ERROR ? errors.push(alert) : others.push(alert);
                this.alerts = others.concat(errors);
            }
        },

        clearAlerts() {
            this.alerts = [];
        },

        async getTranslations() {
            if (this.demo) {
                this.t = this.translations;
            } else {
                const lang = this.language === 'in' ? 'id' : this.language;
                const translations = await getStack().getStrings({
                    contentTypes: ['shipping_component', 'checkout_error_strings'],
                    country: this.country,
                    language: lang,
                    merge: true
                });
                this.checkoutStrings = translations;
                this.t = translations;
            }
        },

        getRequiredFormFields() {
            const formFieldSettings = {...fields.DEFAULT, ...fields[this.country]};
            return Object.keys(formFieldSettings).filter((key) => formFieldSettings[key].required);
        },

        async initMixin() {
            await getConfiguration(['Checkout', 'Account', 'Basic']);
            this.getMarketConfig();
            this.country = RunConfigService.getRunConfig().country;
            this.language = RunConfigService.getRunConfig().language;
            this.requiredFields = this.getRequiredFormFields();
            this.isGuest = CheckoutModeService.isGuestCheckout();
            this.user = UserService.getUser() || {};
            this.distributorName = this.distName || this.user && this.user.getDisplayName && this.user.getDisplayName() || "";
            await this.getTranslations();
        }
    }
};

export default mixin;
